import editorialStyle from "../../../../../../components/editorial/style.scss";

import { Fragment } from "preact";
import Link from "../../../../../../components/link";
import FixedTable from "../../../../../../components/fixed-table";
import Accordion from "../../../../../../components/accordion";
import NoWrap from "../../../../../../components/no-wrap";
import namedRoutes from "../../../../../../settings/routes";

import compatibilityData from "./compatibility.json";
import powerStationData from "../../../../../../data/power-stations/bluetti";

const formatNumber = (value, suffix, fallback = "--", digits = 0) => {
  return value
    ? `${new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: digits,
      }).format(value)}${suffix}`
    : fallback;
};

const getRating = (product, powerLevel, connector = null) => {
  const value = connector
    ? product[powerLevel]?.[connector]
    : product[powerLevel];
  return Number.isFinite(value) || typeof value === "undefined"
    ? formatNumber(value, "W")
    : value;
};

const renderTable = (products) => (
  <FixedTable frameless>
    <table>
      <thead>
        <tr>
          <th class={editorialStyle.sticky} />
          <th scope="col" colSpan={4}>
            Charger 2 ports
          </th>
        </tr>
        <tr>
          <th scope="col" class={editorialStyle.sticky}>
            Model
          </th>

          <th scope="col">CHG</th>
          <th scope="col">
            CHG + solar <sup>1</sup>
          </th>
          <th scope="col">
            BAT <sup>2</sup>
          </th>
          <th scope="col">
            BAT + solar <sup>3</sup>
          </th>
        </tr>
      </thead>
      <tbody>
        {products.map((product, index) => {
          const data = powerStationData?.powerStations[product.name];

          return (
            <tr
              key={product.name}
              class={index === 0 ? editorialStyle.rowBorder : null}
            >
              <th
                scope="row"
                class={editorialStyle.sticky}
                style="min-width:80px"
              >
                {data?.link?.href ? (
                  <Link
                    external
                    affiliateData={data.link.affiliateData}
                    affiliate={data.link.affiliate}
                    href={data.link.href}
                  >
                    {product.name}
                  </Link>
                ) : (
                  product.name
                )}
              </th>

              <td>
                {getRating(product, "charger2", "chg")}{" "}
                {product.charger2.requiresBattery && <sup>5</sup>}
              </td>
              <td>
                {getRating(product, "charger2", "chgSolar")}{" "}
                {product.charger2.requiresBattery && <sup>5</sup>}
              </td>
              <td>
                {getRating(product, "charger2", "bat")}{" "}
                {product.charger2.addon && <sup>4</sup>}
                {product.charger2.requiresBattery && <sup>5</sup>}
              </td>
              <td>
                {getRating(product, "charger2", "batSolar")}{" "}
                {product.charger2.addon && <sup>4</sup>}
                {product.charger2.requiresBattery && <sup>5</sup>}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </FixedTable>
);

const Module = ({ showPageLink = false }) => {
  const accordionItems = Object.entries(compatibilityData).map(
    ([seriesName, products], index) => ({
      heading: seriesName,
      content: renderTable(products),
      open: index === 0, // first section open by default
    })
  );

  return (
    <Fragment>
      <Accordion headingsAs="h3" disableContentPadding items={accordionItems} />

      <p class="caption">
        {showPageLink ? (
          <Fragment>
            Direct link to{" "}
            <Link href={namedRoutes.bluetti.charger2.compatibility}>
              compatibility page
            </Link>
            .
          </Fragment>
        ) : null}{" "}
        {/* All compatibility data was confirmed with BLUETTI support. */}
        <strong>1.</strong> CHG output increases to a combined 1,200W max while
        also having input via PV port. <strong>2.</strong> Allows bidirectional
        power to specific BLUETTI power stations and expansion batteries.{" "}
        <strong>3.</strong> BAT output increases to a combined 1,000W max while
        also having input via PV port. <strong>4.</strong> Requires a
        BLUETTI‑specific cable purchased separately. Availability varies by
        model, and several required cables are not yet on the market.{" "}
        <strong>5.</strong> Requires a compatible expansion battery.
      </p>
    </Fragment>
  );
};

export default Module;
